export { ShopTheLookItem } from './shop-the-look-item';
